export default __webpack_public_path__ + "./images/ke.1ff143e3.png";